export function formatDob(dob) {
  const d = new Date(dob)
  let month = '' + (d.getMonth() + 1)
  let day = '' + (d.getDate() + 1)
  const year = d.getFullYear() % 100

  if (month.length < 2) month = '0' + month
  if (day.length < 2) day = '0' + day

  return [month, day, year].join('/')
}
